import './mobileAppBanner.css';
import appBanner from './search__hotel-js-template_appBanner.phtml';
import '../../../../common/Domain/Service/appmetrica';

export default appBanner;